<google-map height="500px" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions">
    <map-marker [position]="markerPosition" [options]="markerOptions">
    </map-marker>
    <map-info-window>
      <span style="font-weight: bold;">{{pname}}</span>
    </map-info-window>
  </google-map>